<template>
  <div>
    <!-- 幕布 -->
    <div class="mubu">
    </div>
    <!-- 验证弹窗 -->
    <div class="pushpage" v-show="yzmflag">
            <p class="pushhead" style="font-family: DINCOROS-Bold;letter-spacing: 0.1em;font-weight: 520;font-size: 30px;">VBEINGS HOLOGRAM LOOKUP</p>
            <div class="yecard"><img :src="productList.img" class="picimg"></div>
            <!-- 验证码 -->
            <p class="pushhead2"><font style="font-family: DINCOROS-Bold;font-weight: 520;font-size: 30px;">{{productList.code}}</font><br>{{productList.name}}</p>
        </div>
        <!-- 水印 -->
        <div class="shuiying" v-show="yzmflag">
            <!-- 弹窗取消点击 -->
            <img src="../assets/cha.png" alt="" class="cha" v-on:click="cha()">
        </div>
  </div>
</template>
<script>
import axios from 'axios';
export default {
    data(){
      return{
        name:"yzPage",
        // 弹窗验证码
        yzm:"",
        // 验证码标志
        yzmflag:"",
        productList: {},
      }
    },
    methods:{
      cha(){
        this.$router.go(-1)
      }      
    },
    mounted(){
      this.yzmflag = this.$store.state.yzmflag;
      var barCode=this.$route.query.barcode;
      axios.get('http://www.vbgift.com:3688/ewem/product/wx/'+barCode, {
                params: {
                    //barCode: '',//请求参数
                },
            }).then(
                (res) => {
                    if(res.data.code == 200)
                    {
                        this.productList = res.data.data;
                        this.productList.img = "http://www.vbgift.com:3688" + this.productList.img;
                    }
                    else
                    {
                        this.productList = "";

                    }


                }
            )
      //console.log("query"+this.$route.query.barcode)

        console.log("yzpageflag"+this.yzmflag)
      }
}

</script>

<style>
@import '../assets/fonts/sourcehansans.css';
@font-face {
  font-family: "DINCOROS-Bold";
  src: url('../assets/fonts/DINCOROS-Bold-2.ttf');
  font-weight: normal;
  font-style: normal;
}
.bodyfont{
    font-family: 'Source Han Sans', sans-serif;
}

.mubu{
  position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgb(15, 15, 15);
    opacity: 0.2;
}
/* 弹窗 */
.pushpage{
    width: 90%;
    height: 693px;
    /* background-image: url(../assets/shuiying.png); */
    background-color: rgb(246, 246, 246);
    border-radius: 10px;
    position: absolute;
    top: 500px;
    left: 5%;
}
.picimg{
    width: 300px;
    height: auto;
    border-radius: 10px;
    margin-top: 10px;

}
.pushhead{
    font-weight: 550;
    font-size: 32px;
    margin-top: 90px;
}
.yecard{
    width: 300px;
    height: 300px;
    border-radius: 10px;
    margin: 0 auto;
}
.pushhead2{
    font-weight: 550;
    font-size: 34px;
    /* margin-top: 50px; */
}
/* 叉叉 */
.cha{
    width: 40px;
    height: 40px;
    position: absolute;
    top: 20px;
    left: 610px;
    z-index: 1;
}
/* 水印 */
.shuiying{
    width: 90%;
    height: 613px;
    background-image: url(../assets/shuiying.png);
    background-size: 100%;
    /* background-color: rgb(174, 50, 50); */
    border-radius: 10px;
    position: absolute;
    top: 500px;
    left: 5%;
}
</style>